import React from "react";
import { Typography } from "../typography/index.tsx";
import { Container } from "../styled.ts";
import { DeleteIcon } from "../icons/index.tsx";
import { Tick } from "../icons/index.tsx";

export const Tile = ({ id, title, subtitle, active = "Y" }) => {
  const isDisabled = active === "N";
  return (
    <Container
      id={id}
      height="100%"
      className="tile"
      width="340px"
      justifyContent="space-between"
      alignItems="center"
      border="solid 1px #EEEEEE"
      radius="14.4px"
      padding="12px"
      style={{
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
      }}
    >
      <Container column gap="12px">
        <Typography
          fontFamily="Neue Montreal"
          fontSize={"18px"}
          fontWeight={500}
          lineHeight={"21.6px"}
          color="#1E1E1E"
        >
          {title}
        </Typography>
        <Typography
          fontFamily="Neue Montreal"
          fontWeight={400}
          fontSize={"14px"}
          lineHeight={"16.8px"}
          color="#828282"
        >
          {subtitle}
        </Typography>
      </Container>
      <Container
        padding="10px"
        border="solid 1px #E4E4E4"
        radius="12px"
        alignItems="center"
        height="45px"
        className="delete"
      >
      <DeleteIcon className="delete" color="#F10303" width="20" height="20" />
      </Container>
    </Container>
  );
};
